import React, { ReactNode, useContext, useEffect, useState } from 'react';

import BuildingContext from '@totem/components/portfolio/buildings/details/container/BuildingContext';
import { BuildingDetails } from '@totem/components/portfolio/buildings/details/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { BUILDINGS_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  refresh?: boolean;
  onDataRefreshRequested?: () => void;
  children?: ReactNode;
  id: string;
};
const BuildingContainer = ({
  id,
  children,
  refresh,
  onDataRefreshRequested,
}: Props) => {
  const { userProfile, getApiToken } = useContext(UserProfileContext);
  const [data, setData] = useState<BuildingDetails>(null);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (
      refresh &&
      typeof onDataRefreshRequested !== 'undefined' &&
      onDataRefreshRequested !== null
    ) {
      setRefreshData(true);

      onDataRefreshRequested();
    }
  }, [refresh, onDataRefreshRequested]);

  useEffect(() => {
    setRefreshData(true);
  }, [userProfile.organization.id]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      fetch(`${BUILDINGS_ENDPOINT}/${id}`, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: BuildingDetails) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, refresh, getApiToken]);

  return (
    <BuildingContext.Provider
      value={{
        id,
        data,
        isLoading,
        requestRefresh: () => setRefreshData(true),
      }}
    >
      <div>{children}</div>
    </BuildingContext.Provider>
  );
};
export default BuildingContainer;
